<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h5 class="font-medium election-title">📑 Societies List For Audit Verification Detail</h5>
    </div>
    <div class="card-body">
      <!-- Row -->

      <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rowses"
        [columns]="columnss" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [externalPaging]="true"
        [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize" (page)="setPage($event)"
        [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true" [loadingIndicator]="loading">
        <!-- S.No. Column -->
        <ngx-datatable-column name="#" [sortable]="false">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <span>{{ (page.pageNumber) * page.pageSize + rowIndex + 1 }}</span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Dynamic Columns -->
        <ngx-datatable-column  *ngFor="let col of columnss" [sortable]="true" [name]="col.name" [prop]="col.prop">
          <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
            {{ value }}
          </ng-template>
        </ngx-datatable-column>

        <!-- Action Column -->
        <ngx-datatable-column name="Action" [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a class="btn btn-sm btn-outline-primary"
              (click)="assignSocietyForAuditVerification(row.iSocietyDetailID,row.iSocietyDetailsTranID)">
              <i class="bi bi-pencil-square me-1"></i> Edit
          </a>
          </ng-template>
        </ngx-datatable-column>
        
      </ngx-datatable>

    </div>

  </div>
</div>